import {
    DefenseAssign,
    MovePlayer,
    PassBall,
    AddComment,
    WaveMove,
    DrawRectangle,
    DrawEllipse,
    ZoneMove,
    SetPick,
    Comeback,
    Corner,
    Curl,
    Dig,
    Go,
    Out,
    Post,
} from '@labradorsports/assets';

import PlayConfig from './play-config.js';

const { ToolTypes } = PlayConfig;

const Tools = {
    Move: {
        name: 'Move',
        type: ToolTypes.MOVE,
        icon: <MovePlayer />,
    },
    Routes: {
        name: 'Routes',
        type: ToolTypes.ROUTES,
        icon: <MovePlayer />,
    },
    RouteGo: {
        name: 'Go',
        type: ToolTypes.ROUTE_GO,
        icon: <Go />,
    },
    RoutePost: {
        name: 'Post',
        type: ToolTypes.ROUTE_POST,
        icon: <Post />,
    },
    RouteCorner: {
        name: 'Corner',
        type: ToolTypes.ROUTE_CORNER,
        icon: <Corner />,
    },
    RouteDig: {
        name: 'Dig',
        type: ToolTypes.ROUTE_DIG,
        icon: <Dig />,
    },
    RouteOut: {
        name: 'Out',
        type: ToolTypes.ROUTE_OUT,
        icon: <Out />,
    },
    RouteCurl: {
        name: 'Curl',
        type: ToolTypes.ROUTE_CURL,
        icon: <Curl />,
    },
    RouteComeback: {
        name: 'Comeback',
        type: ToolTypes.ROUTE_COMEBACK,
        icon: <Comeback />,
    },
    PreSnap: {
        name: 'Pre-Snap',
        type: ToolTypes.PRESNAP,
        icon: <WaveMove />,
    },
    Zone: {
        name: 'Zone',
        type: ToolTypes.ZONE,
        icon: <ZoneMove />,
    },
    Block: {
        name: 'Block',
        type: ToolTypes.BLOCK,
        icon: <SetPick />,
    },
    Snap: {
        name: 'Snap',
        icon: <PassBall />,
        type: ToolTypes.SNAP,
    },
    Pass: {
        name: 'Pass',
        icon: <PassBall />,
        type: ToolTypes.PASS,
    },
    Handoff: {
        name: 'Handoff',
        icon: <PassBall />,
        type: ToolTypes.HANDOFF,
    },
    Option: {
        name: 'Option',
        type: ToolTypes.OPTION,
        icon: <DefenseAssign />,
    },
    Assign: {
        name: 'Assign',
        type: ToolTypes.ASSIGN,
        icon: <DefenseAssign />,
    },
    Comment: {
        name: 'Comment',
        icon: <AddComment />,
        type: ToolTypes.COMMENT,
    },
    Rectangle: {
        name: 'Rectangle',
        icon: <DrawRectangle />,
        type: ToolTypes.RECTANGLE,
    },
    Ellipse: {
        name: 'Ellipse',
        icon: <DrawEllipse />,
        type: ToolTypes.ELLIPSE,
    },
};

const playerMovement: any[] = [Tools.Move, Tools.Routes, Tools.PreSnap, Tools.Zone, Tools.Assign, Tools.Block];

/** Order: clockwise from Back in `FootballRouteToolRing`. */
const routeTools: any[] = [
    Tools.RouteComeback,
    Tools.RouteOut,
    Tools.RouteCorner,
    Tools.RouteGo,
    Tools.RoutePost,
    Tools.RouteDig,
    Tools.RouteCurl,
];

const ballMovement: any[] = [Tools.Pass, Tools.Option, Tools.Snap, Tools.Handoff];

const fieldMarkup: any[] = [Tools.Comment, Tools.Rectangle, Tools.Ellipse];

const moveShapes = [
    {
        type: ToolTypes.MOVE,
        icon: <MovePlayer />,
    },
    {
        type: ToolTypes.BLOCK,
        icon: <SetPick />,
    },
    {
        type: ToolTypes.PRESNAP,
        icon: <WaveMove />,
    },
    {
        type: ToolTypes.ZONE,
        icon: <ZoneMove />,
    },
];

export default {
    playerMovement,
    routeTools,
    ballMovement,
    fieldMarkup,
    moveShapes,
};
